import { DescriptionPage_CourseType } from '__generated__/graphql-types';

import CourseTypeMetadataV1, { CourseType } from 'bundles/naptimejs/resources/courseTypeMetadata.v1';

const GQL_TO_NAPTIME_COURSE_TYPE: Partial<Record<DescriptionPage_CourseType, CourseType>> = {
  [DescriptionPage_CourseType.StandardCourse]: CourseType.STANDARD_COURSE,
  [DescriptionPage_CourseType.Project]: CourseType.PROJECT,
  [DescriptionPage_CourseType.RhymeProject]: CourseType.RHYME_PROJECT,
};

export const gqlCourseTypeToNaptimeCourseType = (
  courseType: DescriptionPage_CourseType | null | undefined
): CourseTypeMetadataV1 | undefined => {
  const typeName = courseType ? GQL_TO_NAPTIME_COURSE_TYPE[courseType] : undefined;
  if (!typeName) {
    return undefined;
  }
  return new CourseTypeMetadataV1({ courseTypeMetadata: { typeName } });
};
